import { render, staticRenderFns } from "./GeneralStats.vue?vue&type=template&id=6f6e496c&"
import script from "./GeneralStats.vue?vue&type=script&lang=js&"
export * from "./GeneralStats.vue?vue&type=script&lang=js&"
import style0 from "./GeneralStats.vue?vue&type=style&index=0&id=6f6e496c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports